import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15115">
      <span className="sr-only" data-id="element-15116">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-15117">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-15118" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15119" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-15120">
        <div className="flex gap-8" data-id="element-15121">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-15122">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15123" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15124">
        <div className="space-y-6" data-id="element-15125">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15126">
            <div data-id="element-15127">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-15128" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15129" />
            </div>
            <div data-id="element-15130">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15131" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15132" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-15133">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-15134" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-15135" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15136">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15137">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-15138" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15139" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-15140">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-15141" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15142" />
      </div>
    </div>;
}